import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconLogo(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
        <g id="Logo" transform="translate(4.000000, 5.000000)">
          <rect id="Rectangle" x="10" y="0" width="3" height="22" rx="1.5"></rect>
          <rect id="Rectangle-Copy" x="15" y="3" width="3" height="16" rx="1.5"></rect>
          <rect id="Rectangle-Copy-2" x="20" y="6" width="3" height="10" rx="1.5"></rect>
          <rect id="Rectangle-Copy-3" x="5" y="3" width="3" height="16" rx="1.5"></rect>
          <rect id="Rectangle-Copy-4" x="0" y="6" width="3" height="10" rx="1.5"></rect>
        </g>
      </g>
    </Icon>
  )
}
